module.exports = __webpack_public_path__ + "static/media/Left Lateral.e99000f4.png";